module.exports = __webpack_public_path__ + "static/media/FontAwesome5_Brands.c39278f7.ttf";